import React from "react";
import {Button} from "react-bootstrap";

import avatar from '../../../assets/img/demo/player-avatar-7.png';
import SimpleScrollbar from "../../ui/custom_scrollbars/SimpleScrollbar";

const Request = (props) => {

    const onSendRequestClick = () => {
        if(props.onSendRequestClick)
            props.onSendRequestClick();
    }

    return (
        <div className="contact-wrapper">
            <SimpleScrollbar className="contact-scroll" maxHeight="calc(100vh - 165px)">
                <div className="contact-info">
                    <img src={avatar} alt="Player image"/>
                    <h2>Gregory Bell</h2>
                    <span>Scout | Canberry Football Club</span>
                    <p>Short bio if available Esse excepteur proident tempor anim laborum sint et eiusmod id elit consesde.Esse excepteur proident tempor anim laborum sint et eiusmod id elit consesde.Esse excepteur proident tempor anim laborum sint et eiusmod id elit consesde.</p>
                </div>

                {
                    props.type === 'send' && (props.status == 'resend' || props.status == 'pending') ? (
                        <>
                            <div className="contact-detail date">
                                <label>Connection Request Sent On</label>
                                <time>12/26/2019</time>
                            </div>
                            <div className="contact-detail status">
                                <label>Request Status</label>
                                <span>Not Accepted Yet</span>
                            </div>
                        </>
                    ) : null
                }

                {
                    props.type === 'received' ? (
                        <div className="contact-detail date">
                            <label>Connection Request Receive On</label>
                            <time>12/26/2019</time>
                        </div>
                    ) : null
                }

                <div className="contact-request">
                    {
                        props.type === 'send' && props.status == 'send' ? (
                            <Button variant="primary" className="btn-md" onClick={onSendRequestClick}>Send Connection Request</Button>
                        ) : null
                    }

                    {
                        props.type === 'send' && props.status == 'resend' ? (
                            <Button variant="link" className="p-0">Resend Request</Button>
                        ) : null
                    }

                    {
                        props.type === 'received' ? (
                            <Button variant="link" className="p-0">Accepte Request</Button>
                        ) : null
                    }
                </div>
            </SimpleScrollbar>
        </div>
    )
};

export default Request;
